import { render, staticRenderFns } from "./RecentCall.vue?vue&type=template&id=6aa644d4&scoped=true&"
import script from "./RecentCall.vue?vue&type=script&lang=js&"
export * from "./RecentCall.vue?vue&type=script&lang=js&"
import style0 from "./RecentCall.vue?vue&type=style&index=0&id=6aa644d4&prod&lang=scss&"
import style1 from "./RecentCall.vue?vue&type=style&index=1&id=6aa644d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa644d4",
  null
  
)

export default component.exports